/* main.tsx generated by @compiled/babel-plugin v0.35.0 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./main.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { IconButton } from '@atlaskit/button/new';
import Button from '@atlaskit/button/standard-button';
import { Drawer } from '@atlaskit/drawer/compiled';
import ArrowLeft from '@atlaskit/icon/core/migration/arrow-left';
import SuccessIcon from '@atlaskit/icon/core/migration/success--check-circle';
import { IntlMessagesProvider } from '@atlaskit/intl-messages-provider';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import Portal from '@atlaskit/portal';
import { G300 } from '@atlaskit/theme/colors';
import { layers } from '@atlaskit/theme/constants';
import { fetchMessagesForLocale } from '../../common/utils/fetch-messages-for-locale';
import i18nEN from '../../i18n/en';
import messages from '../../messages';
import { FlagEventType, isFlagEventTypeValue } from '../../types';
var styles = {
  drawerCloseButtonContainer: "_kqswstnw _154ipxbi _1ltvpxbi",
  iframe: "_19itglyw"
};
var ANALYTICS_CHANNEL = 'atlas';
var GiveKudosLauncher = function GiveKudosLauncher(props) {
  var _props$recipient;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCloseConfirmModalOpen = _useState2[0],
    setIsCloseConfirmModalOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDirty = _useState4[0],
    setIsDirty = _useState4[1];
  var iframeEl = useRef(null);
  var messageListenerEventHandler = useRef(function (e) {});
  var unloadEventHandler = useRef(function (e) {});
  var intl = useIntl();
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var addFlag = props.addFlag,
    teamCentralBaseUrl = props.teamCentralBaseUrl,
    analyticsSource = props.analyticsSource,
    onClose = props.onClose,
    testId = props.testId;
  var shouldBlockTransition = useCallback(function (e) {
    e.preventDefault();
    e.returnValue = intl.formatMessage(messages.unsavedKudosWarning);
  }, [intl]);
  var sendAnalytic = useCallback(function (action, options) {
    var analyticsEvent = createAnalyticsEvent({
      action: action,
      actionSubject: 'createKudos',
      attributes: _objectSpread(_objectSpread({}, options), {}, {
        analyticsSource: analyticsSource
      })
    });
    analyticsEvent.fire(ANALYTICS_CHANNEL);
  }, [analyticsSource, createAnalyticsEvent]);
  var closeDrawer = useCallback(function () {
    setIsDirty(false);
    setIsCloseConfirmModalOpen(false);
    onClose();
  }, [onClose]);
  var closeWarningModal = function closeWarningModal() {
    setIsCloseConfirmModalOpen(false);
  };
  var createFlagWithJsonStringifiedInput = useCallback(function (flagEvent) {
    var handleCreateOrFail = function handleCreateOrFail(addFlagConfig) {
      closeDrawer();
      sendAnalytic('created', {});
      if (flagEvent.kudosUuid || flagEvent.jiraKudosUrl) {
        addFlag && addFlag(addFlagConfig);
      }
    };
    switch (flagEvent.eventType) {
      case FlagEventType.KUDOS_CREATED:
        handleCreateOrFail({
          title: /*#__PURE__*/React.createElement(FormattedMessage, messages.kudosCreatedFlag),
          id: "kudosCreatedFlag-".concat(flagEvent.kudosUuid),
          description: /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.kudosCreatedDescriptionFlag, {
            values: {
              a: function a(s) {
                return /*#__PURE__*/React.createElement("a", {
                  href: "".concat(teamCentralBaseUrl, "/people/kudos/").concat(flagEvent.kudosUuid)
                }, s);
              }
            }
          })),
          icon: /*#__PURE__*/React.createElement(SuccessIcon, {
            spacing: "spacious",
            label: intl.formatMessage(messages.successIconLabel),
            color: "var(--ds-icon-success, ".concat(G300, ")")
          })
        });
        break;
      case FlagEventType.KUDOS_FAILED:
        handleCreateOrFail({
          title: /*#__PURE__*/React.createElement(FormattedMessage, messages.kudosCreationFailedFlag),
          id: "jiraKudosCreationFailedFlag-".concat(flagEvent.kudosUuid),
          description: /*#__PURE__*/React.createElement(FormattedMessage, messages.kudosCreationFailedDescriptionFlag)
        });
        break;
      case FlagEventType.JIRA_KUDOS_CREATED:
        handleCreateOrFail({
          title: /*#__PURE__*/React.createElement(FormattedMessage, messages.JiraKudosCreatedFlag),
          id: "kudosCreatedFlag-".concat(flagEvent.kudosUuid),
          description: /*#__PURE__*/React.createElement(FormattedMessage, messages.JiraKudosCreatedDescriptionFlag),
          icon: /*#__PURE__*/React.createElement(SuccessIcon, {
            spacing: "spacious",
            label: intl.formatMessage(messages.successIconLabel),
            color: "var(--ds-icon-success, ".concat(G300, ")")
          }),
          actions: [{
            content: 'Track gift request',
            href: flagEvent.jiraKudosUrl
          }, {
            content: 'View kudos',
            href: "".concat(teamCentralBaseUrl, "/people/kudos/").concat(flagEvent.kudosUuid)
          }]
        });
        break;
      case FlagEventType.JIRA_KUDOS_FAILED:
        handleCreateOrFail({
          title: /*#__PURE__*/React.createElement(FormattedMessage, messages.JiraKudosCreationFailedFlag),
          id: "jiraKudosCreationFailedFlag-".concat(flagEvent.kudosUuid),
          description: /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.JiraKudosCreationFailedDescriptionFlag, {
            values: {
              a: function a(s) {
                return /*#__PURE__*/React.createElement("a", {
                  href: flagEvent.jiraKudosFormUrl
                }, s);
              }
            }
          })),
          type: 'warning',
          actions: [{
            content: 'Visit go/kudos',
            href: flagEvent.jiraKudosFormUrl
          }, {
            content: 'View kudos',
            href: "".concat(teamCentralBaseUrl, "/people/kudos/").concat(flagEvent.kudosUuid)
          }]
        });
        break;
      case FlagEventType.DIRTY:
        setIsDirty(true);
        break;
      case FlagEventType.CLOSE:
        closeDrawer();
        break;
      default:
        // Not a known FlagEventType
        return;
    }
  }, [addFlag, closeDrawer, sendAnalytic, teamCentralBaseUrl, intl]);
  var messageListener = useCallback(function (event) {
    if (!props.isOpen) {
      return;
    }
    if (String(event.data).startsWith('kudos-created-') || event.data === 'dirty' || event.data === 'close') {
      if (String(event.data).startsWith('kudos-created-')) {
        var uuid = String(event.data).replace(/^(kudos-created-)/, '');
        closeDrawer();
        sendAnalytic('created', {});
        addFlag && addFlag({
          title: /*#__PURE__*/React.createElement(FormattedMessage, messages.kudosCreatedFlag),
          id: "kudosCreatedFlag-".concat(uuid),
          description: /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.kudosCreatedDescriptionFlag, {
            values: {
              a: function a(s) {
                return /*#__PURE__*/React.createElement("a", {
                  href: "".concat(teamCentralBaseUrl, "/people/kudos/").concat(uuid)
                }, s);
              }
            }
          })),
          icon: /*#__PURE__*/React.createElement(SuccessIcon, {
            spacing: "spacious",
            label: intl.formatMessage(messages.successIconLabel),
            color: "var(--ds-icon-success, ".concat(G300, ")")
          })
        });
      } else if (event.data === 'dirty') {
        setIsDirty(true);
      } else if (event.data === 'close') {
        closeDrawer();
      }
    } else {
      try {
        var eventData = JSON.parse(event.data);
        if (eventData.eventType && isFlagEventTypeValue(eventData.eventType)) {
          createFlagWithJsonStringifiedInput(eventData);
        }
      } catch (e) {
        // Swallow any errors
      }
    }
  }, [props.isOpen, closeDrawer, sendAnalytic, addFlag, teamCentralBaseUrl, createFlagWithJsonStringifiedInput, intl]);
  useEffect(function () {
    window.removeEventListener('message', messageListenerEventHandler.current);
    messageListenerEventHandler.current = messageListener;
    window.addEventListener('message', messageListenerEventHandler.current, false);
    return function () {
      window.removeEventListener('message', messageListenerEventHandler.current);
    };
  }, [messageListener]);
  useEffect(function () {
    window.removeEventListener('beforeunload', unloadEventHandler.current);
    if (isDirty) {
      unloadEventHandler.current = shouldBlockTransition;
      window.addEventListener('beforeunload', unloadEventHandler.current, false);
    }
    return function () {
      window.removeEventListener('beforeunload', unloadEventHandler.current);
    };
  }, [isDirty, shouldBlockTransition]);
  var sendCancelAnalytic = function sendCancelAnalytic() {
    sendAnalytic('cancelled', {});
  };
  var handleCloseDrawerClickedFunc = function handleCloseDrawerClickedFunc() {
    if (!isDirty) {
      sendCancelAnalytic();
      closeDrawer();
      return;
    }
    setIsCloseConfirmModalOpen(true);
  };
  var handleCloseDrawerClickedFuncRef = useRef(handleCloseDrawerClickedFunc);
  useEffect(function () {
    handleCloseDrawerClickedFuncRef.current = handleCloseDrawerClickedFunc;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDirty]);
  var handleCloseDrawerClicked = function handleCloseDrawerClicked() {
    handleCloseDrawerClickedFuncRef.current();
  };
  var recipientParam = props.recipient ? "&type=".concat(props.recipient.type, "&recipientId=").concat(props.recipient.recipientId) : '';
  var giveKudosUrl = "".concat(props.teamCentralBaseUrl, "/give-kudos?cloudId=").concat(props.cloudId).concat(recipientParam, "&unsavedMessage=").concat(intl.formatMessage(messages.unsavedKudosWarning));
  var renderDrawer = useMemo(function () {
    if (props.isOpen) {
      sendAnalytic('opened', {});
    }
    return /*#__PURE__*/React.createElement(Drawer, {
      width: "full",
      isOpen: props.isOpen,
      zIndex: layers.modal(),
      onClose: handleCloseDrawerClicked
    }, /*#__PURE__*/React.createElement("div", {
      className: ax([styles.drawerCloseButtonContainer])
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: handleCloseDrawerClicked,
      icon: ArrowLeft,
      label: intl.formatMessage(messages.closeDrawerButtonLabel),
      shape: "circle",
      appearance: "subtle"
    })), /*#__PURE__*/React.createElement("iframe", {
      src: giveKudosUrl,
      ref: iframeEl,
      width: "100%",
      height: "100%",
      frameBorder: "0",
      allow: "camera;microphone",
      className: ax([styles.iframe])
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(_props$recipient = props.recipient) === null || _props$recipient === void 0 ? void 0 : _props$recipient.recipientId, props.isOpen]);
  return /*#__PURE__*/React.createElement(Portal, {
    zIndex: layers.modal()
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(ModalTransition, null, isCloseConfirmModalOpen && /*#__PURE__*/React.createElement(Modal, {
    onClose: closeWarningModal,
    width: "small"
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.confirmCloseTitle))), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.unsavedKudosWarning)), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    onClick: closeWarningModal,
    autoFocus: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.unsavedKudosWarningCancelButton)), /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    onClick: function onClick() {
      sendCancelAnalytic();
      closeDrawer();
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.unsavedKudosWarningCloseButton))))), renderDrawer));
};
var ComposedGiveKudosLauncher = function ComposedGiveKudosLauncher(props) {
  return /*#__PURE__*/React.createElement(IntlMessagesProvider, {
    loaderFn: fetchMessagesForLocale,
    defaultMessages: i18nEN
  }, /*#__PURE__*/React.createElement(GiveKudosLauncher, props));
};
export default ComposedGiveKudosLauncher;